import React from "react";
import { getCarrier } from "actions/Monitoring";

/**
 * Custom hook para manejar la lógica de estado del trip
 */
export const useTripData = (data) => {
  const [carrier, setCarrier] = React.useState("");
  const [status, setStatus] = React.useState();

  React.useEffect(() => {
    if (data) {
      const { operator, detailTrip } = data;

      if (operator) {
        getCarrier(operator.idCarrier).then((response) => {
          setCarrier("");
        });
      }

      if (detailTrip) {
        let className = "w-full flex justify-center rounded text-[white] ";
        if (detailTrip[0].status === "Finished") {
          setStatus(className + "bg-green-500");
        } else if (detailTrip[0].status === "InProcess") {
          setStatus(className + "bg-yellow-500");
        } else if (detailTrip[0].status === "Pending") {
          setStatus(className + "bg-red-500");
        } else if (detailTrip[0].status === "NotStarted") {
          setStatus(className + "bg-gray-500");
        } else {
          setStatus(className + "bg-blue-500");
        }
      }
    }
  }, [data]);

  return { carrier, status };
};
